import React, { useContext, useEffect, useState } from 'react';
import { ContextDispatchHireOrders } from '../LetterHire';
import { MenuItem, SelectField, TextField } from 'material-ui';
import _ from 'lodash';
import { HIRE_TYPES_MAP } from 'constants/hire';
import CargoRegion from './CargoRegion';
import CargoName from './CargoName';

const Fields = ({ hireOrder, orderIndex }) => {
    const [order, setOrder] = useState(hireOrder);
    /** @type {import('../hireOrdersReducer').TDispatchHireOrders} */
    const dispatchHireOrders = useContext(ContextDispatchHireOrders);

    useEffect(() => {
        setOrder(hireOrder);
    }, [hireOrder]);

    const updateField = (field, value) => {
        const _order = _.cloneDeep(order);

        _order[field] = value;

        dispatchHireOrders({
            type: 'UPDATE_ORDER',
            payload: { index: orderIndex, value: _order },
        });
    };

    return (
        <div>
            <div className='row'>
                <div className='col-xs-3 flexed'>
                    <SelectField 
                        value={hireOrder.hireType}
                        onChange={(_e, _i, value) => updateField('hireType', value)}
                        style={{ fontSize: '13px' }}
                        name='hireType'
                        floatingLabelText='Hire Type'
                        fullWidth
                        autoWidth
                    >
                        {
                            HIRE_TYPES_MAP.map(t => (
                                <MenuItem key={t.field} value={t.field} primaryText={t.placeHolder} />
                            ))
                        }
                    </SelectField>
                </div>
                <div className='col-xs-3 flexed'>
                    <TextField
                        name='hire'
                        floatingLabelText='Hire'
                        value={hireOrder.hire || ''}
                        style={{ fontSize: '13px' }}
                        onChange={e => updateField('hire', e.target.value)}
                        type='number'
                        required
                    />
                </div>
                <div className='col-xs-3 flexed'>
                    <TextField
                        name='duration'
                        floatingLabelText='Duration'
                        style={{ fontSize: '13px' }}
                        value={hireOrder.duration || ''}
                        onChange={e => updateField('duration', e.target.value)}
                    />
                </div>
            </div>
            <div className='row'>
                <div className='col-xs-3 flexed'>
                    <CargoName cargo={hireOrder.cargo} updateField={updateField} />
                </div>
                <div className='col-xs-3 flexed'>
                    <CargoRegion cargoRegion={hireOrder.cargoRegion} updateField={updateField} />
                </div>
            </div>
        </div>
    );
};

export default Fields;



// WEBPACK FOOTER //
// ./app/components/Letters/SingleNew/Hire/content/Fields.jsx